module.exports = __webpack_public_path__ + "img/album14_38.95e5174c.jpg";